import type { ApiService } from "@/domains/api/api-service"
import type { StatsEqualizerResponse } from "@/domains/validators"

export class ScaleStatsApiTransport {
  constructor(private apiService: ApiService) {}

  /**
   * Load scale stats from API
   * Pure data loading - no state, no caching, no side effects
   */
  async loadScaleStats(): Promise<StatsEqualizerResponse> {
    const response = await this.apiService.getStatsEqualizer()
    return response as StatsEqualizerResponse
  }
}
